export default {"src":"/_next/static/media/RTF.7af4f8c0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};